(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = Array.from(this.querySelectorAll('predictive-search'));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearches && this.predictiveSearches.some((search) => search.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Typewriter search placeholder (Baby Skin Store)
  (() => {
    const rotator = document.querySelector('.custom-search-rotator');
    if (!rotator) return;
    const input = document.getElementById('BssHeaderSearchInput');
    const wordEl = rotator.querySelector('.custom-search-rotator__word');
    if (!input || !wordEl) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let suggestions = [];
    try {
      suggestions = JSON.parse(rotator.dataset.suggestions)
        .map((s) => s.trim())
        .filter(Boolean);
    } catch (e) {
      return;
    }
    if (suggestions.length < 2) return;

    const TYPE_SPEED = 90;
    const DELETE_SPEED = 45;
    const holdTime = Math.max(1200, parseInt(rotator.dataset.rotationSpeed, 10) || 3000) - 1200;

    let index = 0;
    let charCount = suggestions[0].length; // first word is server-rendered in full
    let deleting = true;
    let timer = null;

    const shouldPause = () => document.activeElement === input || input.value.length > 0;

    function step() {
      let delay;
      if (shouldPause()) {
        delay = 500;
      } else if (deleting) {
        charCount--;
        wordEl.textContent = suggestions[index].slice(0, charCount);
        if (charCount === 0) {
          deleting = false;
          index = (index + 1) % suggestions.length;
          delay = 350;
        } else {
          delay = DELETE_SPEED;
        }
      } else {
        charCount++;
        wordEl.textContent = suggestions[index].slice(0, charCount);
        if (charCount === suggestions[index].length) {
          deleting = true;
          delay = holdTime;
        } else {
          delay = TYPE_SPEED;
        }
      }
      timer = setTimeout(step, delay);
    }

    function start() {
      if (timer) return;
      timer = setTimeout(step, 2000);
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
    }

    // Don't run timers in background tabs
    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });
    input.addEventListener('focus', stop);
    input.addEventListener('blur', () => {
      if (!input.value) start();
    });

    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
